import { FormControl, InputLabel, Select, MenuItem } from '@mui/material'
import { MUISelectProps } from './Common.types'

export const MUISelect = ({
  selectedTemplate,
  handleChange,
  menuData,
  label,
}: MUISelectProps) => {
  return (
    <FormControl fullWidth>
      <InputLabel id="simple-select-label">{label}</InputLabel>
      <Select
        labelId="simple-select-label"
        id={`simple-Select-${label}`}
        value={selectedTemplate}
        label={label}
        onChange={handleChange}
      >
        <MenuItem value="">
          <em>None</em>
        </MenuItem>
        {menuData.map((item, index: number) => (
          <MenuItem key={`key${item.value}`} value={item.value}>
            {item.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}
